import React, { useState } from "react";
import axios from "axios";
import WeatherTemperature from "./WeatherTemperature";
import FormattedDateDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherForecast from "./WeatherForecast";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);
  //let [message, setMessage] = useState(null);
  //let [loaded, setLoaded] = useState(false);

  function handleResponse(response) {
    console.log(response.data);
    setWeatherData({
      ready: true,
      temperature: response.data.temperature.current,
      description: response.data.condition.description,
      humidity: response.data.temperature.humidity,
      wind: response.data.wind.speed,
      icon: response.data.condition.icon,
      date: new Date(response.data.time * 1000),
      city: response.data.city,
      coord: response.data.coordinates,
    });
  }

  function search() {
    const apiKey = "o3d77t41a2a0ce9d42f448b54f6283dd";
    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
    //setLoaded(true);
  }

  if (weatherData.ready) {
    return (
      <>
        <div classsName="container">
          <div className="box-weather">
            <form id="searchCity" onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-8">
                  <input
                    type="search"
                    className="form-control"
                    id="city-input"
                    placeholder="Enter a city..."
                    autoComplete="off"
                    onChange={handleCityChange}
                  />
                </div>
                <div className="col-4">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    id="current-city"
                  >
                    Search
                  </button>
                </div>
              </div>
            </form>
            <br />
            <h2 id="city">{weatherData.city}</h2>
            <div className="date-description">
              <span id="date">
                {" "}
                Last updated: <FormattedDateDate date={weatherData.date} />
              </span>
              <br />
              <span id="description" style={{ textTransform: "capitalize" }}>
                {" "}
                {weatherData.description}{" "}
              </span>
            </div>
            <div className="row">
              <div className="col current-weather">
                <span className="todays-weather">
                  <div className="row mt-3">
                    <div className="col-sm-4 icon">
                      <WeatherIcon code={weatherData.icon} size={60} />
                    </div>
                    <div className="col-sm-8 temp">
                      {" "}
                      <WeatherTemperature
                        celsius={Math.round(weatherData.temperature)}
                      />
                    </div>
                  </div>{" "}
                </span>
              </div>
              <div className="col additional-data">
                <br />
                Humidity: <span id="humidity">{weatherData.humidity}</span>%
                <br />
                Wind: <span id="wind">{weatherData.wind}</span> m/s
              </div>
            </div>
            <WeatherForecast coords={weatherData.coord} />
          </div>
        </div>
      </>
    );
  } else {
    search();
    return "Loading...";
  }
}
